/**
 * @fileOverview Provides the UI for filtering the pickup page and passes down
 * the filtered values
 */
import React from 'react'
import styled from 'styled-components'
import GlobalSearch from './GlobalSearch'

const FixedGlobalSearch = props => {
  return (
    <GlobalFilterContainer>
      <GlobalSearch {...props} />
    </GlobalFilterContainer>
  )
}

const GlobalFilterContainer = styled.div`
  padding: 25px 40px;
  background: #f8f8f8;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 1;
`

export default FixedGlobalSearch



// WEBPACK FOOTER //
// ./src/Components/FixedGlobalSearch/FixedGlobalSearch.js